import { render, staticRenderFns } from "./comparativasEntregas.vue?vue&type=template&id=7e86d965&"
import script from "./comparativasEntregas.vue?vue&type=script&lang=js&"
export * from "./comparativasEntregas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports